import { type FC, memo, useMemo } from "react";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import type { MarkdownContentProps } from "./types";
import { stripPendingTag } from "./stripPendingTag";
import { MarkdownWrapper } from "./MarkdownContent.styles";

const rehypePlugins = [rehypeRaw];

const MarkdownContent: FC<MarkdownContentProps> = memo(
  ({ text, isStreaming, components, customElements }) => {
    const safeText = isStreaming ? stripPendingTag(text) : text;
    const breakText = safeText.replace(/\n/g, "  \n");

    const mergedComponents = useMemo(() => {
      const divHandler = customElements
        ? ({
            node,
            type,
            ...props
          }: {
            node?: unknown;
            type?: string;
            [key: string]: unknown;
          }) => {
            if (type?.startsWith("9am:")) {
              const Component = customElements[type];
              return Component ? <Component attrs={props} /> : null;
            }
            return <div {...props} />;
          }
        : undefined;

      return {
        ...(divHandler ? { div: divHandler } : {}),
        ...components
      } as Record<string, React.ElementType>;
    }, [components, customElements]);

    return (
      <MarkdownWrapper>
        <ReactMarkdown
          rehypePlugins={rehypePlugins}
          components={mergedComponents}
        >
          {breakText}
        </ReactMarkdown>
      </MarkdownWrapper>
    );
  }
);

export { MarkdownContent };
